import { Component, forwardRef, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { Message, OverlayPanel, SelectItem } from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'

//constants
import { Constants } from '../../constants/Constants';

//base
import { BaseDropdownComponent } from '../../baseclasses/BaseDropdown.component';

@Component({
    selector: 'my-mass-update-entity-dropdown',
    templateUrl: './MassUpdateEntityDropdown.component.html',
    providers: [{ provide: BaseDropdownComponent, useExisting: forwardRef(() => MassUpdateEntityDropdownComponent) }]
})
export class MassUpdateEntityDropdownComponent extends BaseDropdownComponent {

    constructor(private domainDataService: serv.DomainDataService) {
        super();
    }


    ngOnInit(): void {
        this.load();
    }

    public load() {

        this.domainDataService.getMassUpdateEntities().subscribe(x => this.onGetRecordsDone(x));
    }

    onGetRecordsDone(items: ent.MassUpdateEntity[]) {
        items.forEach(y => this.selectItems.push({ label: y.Name, value: y.ID }));
        this.value = this.selectedID;
    }

}